import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Collapse, Form, FormGroup, Label, Row,} from 'reactstrap';

import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    deleteErrorMsg,
    deleteMsg,
    error,
    NO,
    warning,
    YES,
} from "../../../components/i18n/i18n";
import {showToastCustom} from "../../../components/toast/customToast";
import {confirmAlert} from "react-confirm-alert";
import {utilHelper} from "../../../jwt/_helpers";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import {
    ButtonClean,
    ButtonSearch,
    ButtonTableDelete,
    ButtonTableEdit,
    ButtonTableFilter
} from "../../../components/buttons/buttonsActions";
import {showLoader} from "../../../components/loader/loader";
import BootstrapTable from "react-bootstrap-table-next";
import {scheduleService} from "../../../jwt/_services/clasificator/scheduleService";
import Select, {makeAnimated} from "react-select";
import {useForm} from "react-hook-form";
import {typeSeasonProvider} from "../../../providers/typeSeasonProvider";
import {seasonService} from "../../../jwt/_services/clasificator/seasonService";

export const ScheduleList = forwardRef((props, ref) => {

    const animatedComponents = makeAnimated();

    const [activity] = useState(props.activity);

    const [collapsed, setCollapsed] = useState(false);
    const [listItems, setListItems] = useState([]);
    const [loading, setLoading] = useState(false);

    const [typeSeasonOptions, setTypeSeasonOptions] = useState([]);
    const [typeSeason, setTypeSeason] = useState(null);
    const [typeSeasonToday, setTypeSeasonToday] = useState(null);

    useEffect(() => {
        setLoading(true);

        let dataRequest = {
            activity: {id: activity?.id},
            typeSeason: { id: null}
        };

        typeSeasonProvider.getOptions()
            .then(result => {
                if (result)
                    setTypeSeasonOptions(result);
                setLoading(false);
            })
            .catch(_ => {
                setTypeSeasonOptions([]);
                setLoading(false);
            })

        seasonService.getSeasonToday()
            .then(_typeSeasonToday => {
                if (_typeSeasonToday) {
                    setTypeSeasonToday(_typeSeasonToday);
                    setTypeSeason(_typeSeasonToday);
                    dataRequest.typeSeason =  { id: _typeSeasonToday.id}
                }

                refreshDataList(dataRequest);
            })
            .catch(_ => {
                refreshDataList(dataRequest);
            })
    }, []);

    const handleTableChange = () => {
        const dataRequest = {
            activity: {id: activity?.id},
            typeSeason: {id: (typeSeason?.id ? typeSeason.id : null)}
        };

        refreshDataList(dataRequest);
    };

    const refreshDataList = (dataRequest) => {
        setLoading(true);
        setListItems([]);

        scheduleService.search(dataRequest)
            .then(result => {
                setLoading(false);
                setListItems(result);
            })
            .catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    useImperativeHandle(ref, () => ({
        refreshList() {
            const dataRequest = {
                activity: {id: activity?.id},
                typeSeason: {id: (typeSeason?.id ? typeSeason.id : null)}
            };

            refreshDataList(dataRequest);
        }
    }));

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const {handleSubmit, reset} = useForm({});

    const onSubmit = (data, _) => {
        const dataRequest = {
            activity: {id: activity?.id},
            typeSeason: {id: (typeSeason?.id ? typeSeason.id : null)}
        };

        refreshDataList(dataRequest);
    };

    const showFilters = () => {
        setCollapsed(!collapsed);
    }

    const cleanFields = () => {
        setLoading(true);
        reset();
        setTypeSeason(null);

        const dataRequest = {
            activity: {id: activity?.id},
            typeSeason: {id: null}
        };

        refreshDataList(dataRequest);
    }

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const onTypeSeasonChange = (value) => {
        setTypeSeason(value);
    }

    // ----------------------------------------------
    //            TABLE BUTTONS
    // ----------------------------------------------
    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        setLoading(true);
        scheduleService.deleteItem(data.id)
            .then(_ => {
                setLoading(false);
                props.editItem(false, null);

                const dataRequest = {
                    activity: {id: activity?.id},
                    typeSeason: {id: null}
                };

                refreshDataList(dataRequest);

                if (utilHelper.hasAssociateRecords()) {
                    showToastCustom(error, deleteErrorMsg, true);
                    utilHelper.restartAssociateRecords();
                } else {
                    showToastCustom(warning, deleteMsg, true);
                }
            });
    }

    const editItem = (data) => {
        const itemToEdit = listItems.find(n => n.id === data.id);
        props.editItem(true, itemToEdit);
    }

    // ----------------------------------------------
    //            ROW FORMATTERS
    // ----------------------------------------------
    const activeFormatter = (cell) => {
        return (
            <ActiveFormatter active={cell}/>
        );
    }

    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <ButtonTableDelete onClick={() => confirmDelete(row)}/>
                <ButtonTableEdit onClick={() => editItem(row)}/>
            </div>
        );
    }

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'typeSeasonName',
        text: 'Temporada',
        sort: true
    }, {
        dataField: 'time12',
        text: 'Hora (12)',
        sort: true
    }, {
        dataField: 'time24',
        text: 'Hora (24)',
        sort: true
    }, {
        dataField: 'duration',
        text: 'Duración',
        sort: true
    }, {
        dataField: 'status',
        text: "Activo",
        formatter: activeFormatter
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '20%'},
        formatter: actionsFormatter
    }
    ];

    return (
        <div>
            {loading && showLoader()}
        <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>
                    Hoy es : <Label className="label-type-season-today"> { typeSeasonToday ? ' ' + typeSeasonToday.name   : null }</Label>
                    <div className="float-right">
                        <ButtonTableFilter onClick={() => showFilters()} collapsed={collapsed}/>
                    </div>
                </CardTitle>
                <Collapse isOpen={collapsed}>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <CardBody className="">
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                        <Select name="typeSeason"
                                                value={typeSeason}
                                                options={typeSeasonOptions}
                                                components={animatedComponents}
                                                placeholder="Selecciona un tipo de temporada"
                                                isSearchable={true}
                                                isClearable={true}
                                                onChange={onTypeSeasonChange}/>
                                    </FormGroup>
                                </Col>
                                <Col md="8">
                                    <div className="float-right">
                                        <ButtonSearch />
                                        <ButtonClean onClick={() => cleanFields()}/>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Form>
                </Collapse>
                <CardBody className="">
                        <BootstrapTable
                            striped hover
                            tableHeaderClass='mb-0'
                            remote
                            keyField="id"
                            data={listItems}
                            columns={columns}
                            onTableChange={handleTableChange}
                        />
                </CardBody>
            </Card>
        </div>
    )
});
